
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"M15 23a8 8 0 100-16 8 8 0 000 16z","stroke":"#6E88F3"}}),_c('path',{attrs:{"stroke":"#6E88F3","d":"M19 15.5h-8"}}),_c('path',{attrs:{"d":"M4 1h22v-2H4v2zm25 3v22h2V4h-2zm-3 25H4v2h22v-2zM1 26V4h-2v22h2zm3 3a3 3 0 01-3-3h-2a5 5 0 005 5v-2zm25-3a3 3 0 01-3 3v2a5 5 0 005-5h-2zM26 1a3 3 0 013 3h2a5 5 0 00-5-5v2zM4-1a5 5 0 00-5 5h2a3 3 0 013-3v-2z","fill":"#C7C7C7"}})])
          )
        }
      }
    